<template>
  <div v-if="settlement" class="settlement" data-testid="settlement">
    <span class="channel">{{ channelLabel }}</span>
    <template v-if="settlement.channel === 'cash'">
      <span class="amount">{{ receivedLabel }} {{ formatMoney(settlement.received) }}</span>
      <span v-if="settlement.change > 0" class="change" data-testid="settlement-change">
        เงินทอน {{ formatMoney(settlement.change) }}
      </span>
      <span v-else-if="settlement.overdue > 0" class="overdue" data-testid="settlement-overdue">
        ค้างชำระ {{ formatMoney(settlement.overdue) }}
      </span>
    </template>
    <span v-else-if="referenceLabel" class="reference">{{ referenceLabel }}</span>
  </div>
</template>

<script>
import { formatMoney, formatSettlementReference, PAYMENT_CHANNEL_LABELS } from './format';

export default {
  name: 'SettlementFooter',
  props: {
    settlement: { type: Object, default: null }
  },
  watch: {
    settlement() {
      // v-if replaces the root comment/element when a settlement appears.
      this.$nextTick(this.observeFooter);
    }
  },
  mounted() {
    this.footerObserver = typeof window.ResizeObserver === 'function'
      ? new window.ResizeObserver(this.emitHeight)
      : null;
    window.addEventListener('resize', this.emitHeight);
    this.observeFooter();
  },
  beforeDestroy() {
    if (this.footerObserver) this.footerObserver.disconnect();
    window.removeEventListener('resize', this.emitHeight);
  },
  computed: {
    channelLabel() {
      if (!this.settlement) return '';
      const base = PAYMENT_CHANNEL_LABELS[this.settlement.channel] || this.settlement.channel;
      return this.settlement.direction === 'refund' ? `คืนเงิน - ${base}` : `ชำระด้วย${base}`;
    },
    receivedLabel() {
      return this.settlement && this.settlement.direction === 'refund' ? 'จ่ายคืน' : 'รับเงิน';
    },
    referenceLabel() {
      return this.settlement ? formatSettlementReference(this.settlement.channel, this.settlement.reference) : '';
    }
  },
  methods: {
    formatMoney,
    observeFooter() {
      if (this._isBeingDestroyed || this._isDestroyed) return;
      if (this.footerObserver) {
        this.footerObserver.disconnect();
        if (this.$el.nodeType === 1) this.footerObserver.observe(this.$el);
      }
      this.emitHeight();
    },
    emitHeight() {
      if (this._isBeingDestroyed || this._isDestroyed) return;
      // Layout only: no settlement/payment state is changed or broadcast.
      this.$emit('resize', this.$el.nodeType === 1 ? Math.ceil(this.$el.getBoundingClientRect().height) : 0);
    }
  }
};
</script>

<style scoped>
.settlement {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  gap: 0.5rem 1.5rem;
  padding: 0.7rem 2rem;
  /* Same purple as the total amount, so the footer reads as part of the same
     "money" story instead of a disconnected bar. */
  background: #4c1d95;
  color: #fff;
  font-size: calc(1.6rem * var(--font-scale, 1));
}
.channel {
  font-weight: 600;
}
.change {
  color: #fde047;
  font-weight: 700;
}
.overdue {
  color: #fb923c;
  font-weight: 700;
}
.reference {
  color: #e9d5ff;
}
</style>
